import React, { useEffect, useState } from "react";
import axios from "axios";
import { Monitor01, Phone01, Spinner, Tabs } from "@opendate-app/setlist";

import SampleDataPicker from "./SampleDataPicker";
import { useBroadcastEditContext } from "./BroadcastEditContainer";
import { toastError } from "../../../shared/toastHelper";
import EmailPreviewViewer from "../shared/EmailPreviewViewer";
import { SAMPLE_COLUMN_WIDTH, desktopFrameWidth } from "./emailPreviewWidth";

const containerStyle = {
  background: "var(--sl-bg-primary)",
  boxShadow: "-2px 1px 5px 0 rgba(0,0,0,0.1)",
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
};

const previewColumnStyle = {
  borderLeft: "1px solid var(--sl-border-subtle)",
  color: "var(--sl-text-primary)",
  display: "flex",
  flex: "1 1 320px",
  flexDirection: "column",
  fontSize: "14px",
  minWidth: 0,
};

const detailRowStyle = {
  borderBottom: "1px solid var(--sl-border-subtle)",
  padding: "10px",
};

const sampleDataPickerContainer = {
  boxSizing: "border-box",
  flex: `0 1 ${SAMPLE_COLUMN_WIDTH}px`,
  minWidth: 0,
  padding: 15,
};

const EmailPreviewTab = () => {
  const {
    csrfToken,
    team,
    broadcast,
    template,
    sampleData,
    parseLiquid,
    sampleFanId,
    subject,
    preheader,
    sendDomain,
    beefreeTemplate,
    venueOwnership,
  } = useBroadcastEditContext();

  const [isLoading, setIsLoading] = useState(true);
  const [htmlContent, setHtmlContent] = useState("");
  const [viewer, setViewer] = useState("desktop");
  const [parsedSubject, setParsedSubject] = useState(subject);

  useEffect(() => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.post("/teams/" + team.id + "/beefree_templates/" + beefreeTemplate.id + "/render_liquid_html", {
      beefree_template: {
        template: template,
        sample_data: sampleData,
        venue_ownership_id: venueOwnership?.id,
      },
    })
      .then(({ data }) => {
        setHtmlContent(data.parsedText);
        setIsLoading(false);
      })
      .catch(() => toastError("Could not fetch email preview, please try again"));

    parseLiquid(subject, sampleData, team.id, beefreeTemplate.id, csrfToken).then(({ parsedText }) => {
      setParsedSubject(parsedText);
    });
  }, [template, sampleData]);

  const sampleDataAvailable = !!sampleFanId;

  return (
    isLoading ? (
      <Spinner size="md" aria-label="Loading email preview" />
    ) : (
      <div style={containerStyle}>
        {sampleDataAvailable ? (
          <div style={sampleDataPickerContainer}>
            <SampleDataPicker />
          </div>
        ) : null}
        <div style={previewColumnStyle}>
          <div style={detailRowStyle}>
            <Tabs
              variant="button-border"
              size="sm"
              collapseBelow={0}
              aria-label="Preview size"
              value={viewer}
              onChange={setViewer}
              items={[
                { value: "desktop", label: <><Monitor01 width={16} height={16} /> Desktop</> },
                { value: "mobile", label: <><Phone01 width={16} height={16} /> Mobile</> },
              ]}
            />
          </div>
          <div style={detailRowStyle}><b>From: </b>{sendDomain?.name_with_address}</div>
          <div style={detailRowStyle}><b>To: </b>{sampleData.fan?.email}</div>
          <div style={detailRowStyle}><b>Subject: </b>{parsedSubject}</div>
          {!!preheader ? (
            <div style={detailRowStyle}><b>Preheader: </b>{preheader}</div>
          ) : null}
          <EmailPreviewViewer htmlContent={htmlContent} frameWidth={desktopFrameWidth(template)} viewer={viewer} />
        </div>
      </div>
    )
  );
};

export default EmailPreviewTab;
